import type {ElasticCloudAuthLambda, SearchProps} from '../types';

export const mapToElasticCloudAuthLambda = ({
  target,
  index,
  elasticBody,
}: SearchProps): ElasticCloudAuthLambda => ({target, index, elasticBody});
